import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { currencyFormatter } from "../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader
} from "../../../../../_metronic/_partials/controls";
import Checkbox from "@material-ui/core/Checkbox";
import { getFundtypeAll } from "../../../MasterData/_redux/fund_type/fundtypeCrud"

export default function DonationDetail({ id, data, onSelectType }) {
  const [select, setSelect] = useState([]);
  const [fundType, setFundType] = useState([]);
  const [total, setTotal] = useState({
    amount: 0,
    count: 0
  });

  const handleChangeAll = () => {
    setSelect((prevSelected) => {
      const dataFundType = fundType.map(v => v.name);
      if (prevSelected.length === dataFundType.length) {
        return [];
      }

      return dataFundType;
    });
  }

  const handleChange = (type) => {
    setSelect((prevSelected) => {
      if (prevSelected.includes(type)) {
        return prevSelected.filter((item) => item !== type);
      }

      return [...prevSelected, type];
    });
  }

  const getFundType = async () => {
    try {
      const res = await getFundtypeAll();

      if (res.data.data) {
        setFundType(res.data.data);
      }

    } catch (err) {
      console.log("Get Fund Type Error");
    }
  }

  const selectedAmount = fundType.reduce((sum, v) => {
    if (select.includes(v.name)) {
      let amount = data[`${v.name.toLowerCase()}_amount`] ?? 0;
      return sum + parseInt(amount);
    }
    return sum;
  }, 0);

  const selectedCount = fundType.reduce((sum, v) => {
    if (select.includes(v.name)) {
      let count = data[`${v.name.toLowerCase()}_count`] ?? 0;
      return sum + parseInt(count);
    }
    return sum;
  }, 0);
  
  useEffect(() => {

    if (!id) {
      setTotal({
        amount: selectedAmount,
        count: selectedCount
      });
    }

    if (select.length >= 1) {
      onSelectType(select);

    } else {
      onSelectType([]);
    }
    
  },[select]);

  useEffect(() => {
    getFundType();
  },[])

  const rowsFundType = () => {
    return fundType.map(v => (
      <>
         <tr>
          <td hidden={id} width={20} style={{padding: 0, textAlign: 'center'}}>
                <Checkbox checked={select.includes(v.name)} onChange={() => handleChange(v.name)} />
          </td>
          <td>{v.name}</td>
          <td className="text-right">{data[`${v.name.replace(/\s/g, '_').toLowerCase()}_count`]}</td>
          <td className="text-right">{currencyFormatter(data[`${v.name.replace(/\s/g, '_').toLowerCase()}_amount`])}</td>
        </tr>
      </>
    ));
  }
  

  return (
    <Card>
      <CardHeader title="Rekap Laporan" />
      <CardBody>
        <Table hover>
          <thead>
            <tr>
              <th hidden={id} width={20} style={{padding: 0, textAlign: 'center'}}>
                <p style={{padding: 0, margin: 0, color: '#B5B5C3', fontSize: 11}}>All Select</p>
                <Checkbox checked={select.length === fundType.length} onChange={handleChangeAll}/> 
              </th>
              <th className="text-left">Jenis Dana</th>
              <th width={200} className="text-right">
                Jumlah Transaksi
              </th>
              <th width={200} className="text-right">
                Nominal Transaksi
              </th>
            </tr>
          </thead>
          <tbody>
            {rowsFundType()}
            <tr hidden={id} style={{ fontWeight: "bold" }}>
              <td>Total</td>
              <td hidden={id} ></td>
              <td className="text-right">{total.count}</td>
              <td className="text-right">
                {currencyFormatter(total.amount)}
              </td>
            </tr>
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
}
